module.exports = __webpack_public_path__ + "img/logo-38.caaf481a.svg";